const tabConfig = {
    tabs: [
        /*{
            id: '0',
            radio: 'radio-1',
            intent: 'PromtData',
            label: 'Data',
            icon: 'database',
            dropdownItems: [
                { id: 0, name: "Orders database" },
                { id: 1, name: "CRM database" }
            ],
            visible: true
        },*/
        {
            id: '1',
            radio: 'radio-2',
            intent: 'PromtEmbeddings',
            label: 'Documents',
            icon: 'description',
            dropdownItems: [],
            visible: true
        }/*,
        {
            id: '2',
            radio: 'radio-3',
            intent: 'PromptGpt',
            label: 'Chat',
            icon: 'contact_support',
            dropdownItems: [
                { id: 0, name: "GPT-4o-mini" },
                { id: 1, name: "GPT-4o" }
            ],
            visible: true
        }*/
    ]
};

export default tabConfig;